var c = Object.defineProperty;
var u = (s, r, e) => r in s ? c(s, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[r] = e;
var a = (s, r, e) => u(s, typeof r != "symbol" ? r + "" : r, e);
import { a as p, M as w } from "../../CustomPopupNavigator-BmPvnFg4.js";
import { C as l } from "../../index-D8rQzb7O.js";
import { B as y } from "../../index-BcZ70a8s.js";
class S {
  constructor(r, e, t, o = "daymap-companion") {
    a(this, "client_id");
    a(this, "acr_values");
    a(this, "redirect_uri");
    a(this, "authority");
    a(this, "response_type");
    a(this, "scope");
    a(this, "silent_redirect_uri");
    if (this.client_id = r, this.authority = e, this.response_type = "code", this.scope = "openid offline_access", l.isNativePlatform())
      this.redirect_uri = `${o}://${t}/auth`, this.silent_redirect_uri = `${o}://${t}/authsilent`, this.acr_values = `${o}://${t}/auth`;
    else {
      let i = r === "Connect.API" ? "portal" : "portals/student";
      r === "Daymap.API" && window.location.pathname.toLowerCase().startsWith("/lms/app") && (i = "lms/app"), this.redirect_uri = `${window.location.origin}/${i}/auth`, this.silent_redirect_uri = `${window.location.origin}/${i}/authsilent`, this.acr_values = `${window.location.origin}/${i}/auth`;
    }
  }
}
class k {
  constructor(r, e, t, o) {
    a(this, "UserManager");
    a(this, "isLocked", !1);
    a(this, "onSignInError");
    a(this, "schoolCode");
    this.UserManager = new p(
      r,
      void 0,
      l.isNativePlatform() ? new w() : void 0
    ), this.onSignInError = t, e && (e.toStorageString = () => JSON.stringify(e), this.UserManager.storeUser(e), this.schoolCode = o);
  }
  async GetAccessToken(r) {
    for (; this.isLocked; )
      await new Promise((e) => setTimeout(e, 50));
    this.isLocked = !0;
    try {
      let e = await this.UserManager.getUser();
      if (!e || e.expired) {
        if (r || !e)
          if (l.isNativePlatform())
            try {
              await this.UserManager.signinPopup({ state: window.location.href, prompt: "login" }), y.close();
            } catch (t) {
              console.log("Error returned by signInPopup", t);
            }
          else
            await this.UserManager.signinRedirect({ state: window.location.href });
        else
          await this.UserManager.signinSilent();
        e = await this.UserManager.getUser();
      }
      return e ? e.access_token : "no token";
    } catch {
      return this.onSignInError && this.onSignInError(), this.GetAccessToken(!0);
    } finally {
      this.isLocked = !1;
    }
  }
  async SignOut() {
    try {
      await this.UserManager.signoutSilent();
    } catch (r) {
      console.error(r);
    }
  }
  async GetResponse({ url: r, data: e, config: t }) {
    const o = await this.GetAccessToken(!1);
    if (!o)
      throw Error("No valid access token could be found");
    t || (t = { headers: { "Content-Type": "application/json" } }), t.headers || (t.headers = { "Content-Type": "application/json" }), e != null && e !== void 0 ? (t.method || (t.method = "POST"), t.dontStringify ? t.body = e : t.body = JSON.stringify(e)) : t.method || (t.method = "GET"), t.credentials = "omit", t.headers.Authorization = "Bearer " + o;
    const i = await fetch(r, t);
    if (!i.ok) {
      if (i.status === 401) {
        if (t != null && t.__retried401) throw { title: "Unauthorized", status: 401, detail: "Authentication failed" };
        return t = { ...t ?? {}, __retried401: !0 }, await this.UserManager.removeUser(), await this.GetResponse({ url: r, data: e, config: t });
      }
      const d = await i.text();
      try {
        throw JSON.parse(d);
      } catch {
        throw {
          title: "Error",
          status: i.status,
          detail: d || i.statusText || "An error occurred"
        };
      }
    }
    if (i.status === 204)
      return null;
    if (t.asResponse)
      return i;
    if (t.asBlob)
      return await i.blob();
    if (t.asText)
      return await i.text();
    let n = await i.json();
    return n = h(n), await n;
  }
}
const m = (s) => typeof s == "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(s), h = (s) => s === null || typeof s != "object" ? s : Array.isArray(s) ? s.map(h) : Object.fromEntries(
  Object.entries(s).map(([r, e]) => [
    r,
    m(e) ? new Date(e) : h(e)
  ])
);
export {
  k as DaymapOidc,
  S as DaymapOidcConfig
};
//# sourceMappingURL=daymapoidc.js.map
